const table = [
	{
		name: "移动安全联盟 OAID",
		use: "获取OAID(提供不同移动智能终端开放匿名设备标识符（OAID）设备标识符（VAID）、设备标识符（AAID）、设备信息、App包名及签名信息",
		userType: "设备信息、品牌信息、应用软件信息、设备标识符(OAID)",
		company: "中国信息通信研究院",
		permissions: "/",
		url: "https://www.msa-alliance.cn/col.jsp?id=122",
		collect: "SDK本机采集",
		tips: "移动智能终端补充设备标识体系与 SDK 严格遵守我国《网络安全法》、《数据安全法》和《电信和互联网用户个人信息保护规定》等相关法律法规和《信息安全技术 个人信息安全规范》等国家标准要求。SDK 不会主动收集任何数据，只在 APP 调用时获取以下数据，用于本地判断，不会进行任何网络传输：</br></br> • 设备制造商、设备型号、设备品牌，用于判断终端调用接口</br> • 设备网络运营商名称，用于判断虚拟机环境</br> • APP 包名，用于校验签名"
	},
	{
		name: "阿里weexSDK",
		use: "uni-app基础模块默认集成，用于渲染uniapp的nvue页面引擎",
		userType: "读取外置存储器、写入外置存储器",
		company: "/",
		permissions: "存储的个人文件",
		url: "http://doc.weex.io/zh/",
		collect: "SDK本机采集"
	},
	{
		name: "fastjson",
		use: "无",
		userType: "JSON解析",
		company: "/",
		permissions: "/",
		url: "https://github.com/alibaba/fastjson",
		collect: "SDK本机采集"
	},
	{
		name: "glide图库",
		use: "存储的个人文件",
		userType: "用于图片预览使用",
		company: "/",
		permissions: "存储的个人文件",
		url: "http://bumptech.github.io/glide/",
		collect: "SDK本机采集"
	},
	{
		name: "fresco图片库",
		use: "uni-app基础模块默认集成，用于nvue页面加载图片使用",
		userType: "读取外置存储器、写入外置存储器",
		company: "/",
		permissions: "存储的个人文件",
		url: "https://www.fresco-cn.org/",
		collect: "SDK本机采集"
	},
	{
		name: "gif-drawable	",
		use: "uni-app基础模块默认集成，存储文件",
		userType: "加载gif图",
		company: "/",
		permissions: "读取外置存储器、写入外置存储器",
		url: "https://github.com/koral--/android-gif-drawable",
		collect: "/"
	},
	{
		name: "Bluetooth",
		use: "访问蓝牙设备，包括搜索、连接。",
		userType: "JSON解析",
		company: "/",
		permissions: "访问蓝牙设备、位置信息",
		url: "/",
		collect: "SDK本机采集"
	},
]

export default table
